import React, { Component } from 'react';
import { Label, InputGroup , InputGroupAddon ,InputGroupText ,FormGroup, Input ,FormFeedback ,Tooltip } from 'reactstrap';
import SimpleReactValidator from '../Validator/Validator';

class InputNormal extends Component {

	constructor(props) {
	    super(props);

	    this.validator = new SimpleReactValidator();
	    this.toggle = this.toggle.bind(this);
		this.state = {
	    	invalidField: undefined,
		    tooltipOpen: [false, false]
	    };
	}

	toggle(i) {
	    const newArray = this.state.tooltipOpen.map((element, index) => {
	      return (index === i ? !element : false);
	    });
	    this.setState({
	      tooltipOpen: newArray,
	    });
	}


	isValid(field) {
		let valid = this.validator.fieldValid(field);

		this.setState({
			invalidField: !valid ? true : undefined
		});

		if(!valid)
			this.validator.showMessages();
	}


	render () {

		return (
			<FormGroup className={this.props.className || ''}>
				
				{
					this.props.labelName ? 
					<Label 
						htmlFor={this.props.name ? this.props.name  : '' } 
						className={this.props.labelclass ? this.props.labelclass  : 'text-muted' }>

						{ this.props.labelName }
						{  this.props.unrequired ? null : <i style={{color:'red'}}> *</i> }

					</Label>
					:
					null
				}
					

				<InputGroup className={this.props.mbClass ? this.props.mbClass  : 'mb-3' }>

					{ 	
						/* Coloca un icono o caracter antes del input*/
						this.props.iconPrepend?
						<InputGroupAddon addonType="prepend">
							<InputGroupText>
								{this.props.iconPrepend}
							</InputGroupText>
						</InputGroupAddon>
						:
						null
					}

					{   
						/* Coloca un boton antes del input*/
						this.props.buttonPrepend?
						<InputGroupAddon addonType="prepend">
                        	{this.props.buttonPrepend}
						</InputGroupAddon>
						:
						(null)
					}
					

					{
						this.props.type && this.props.type !== 'email'?
						<Input
							id = {this.props.tooltip ? this.props.name  : undefined } // tooltip necesita ID
							type = { this.props.type ? this.props.type : 'text'}
							name = { this.props.name ? this.props.name  : ''} 
							value = { this.props.value ? this.props.value  : '' } 
							placeholder = { this.props.placeholder ? this.props.placeholder  : ''}
							onKeyUp = { this.props.onKeyUp ? this.props.onKeyUp  : undefined }
							onKeyDown = { this.props.onKeyDown ? this.props.onKeyDown  : undefined }
							onKeyPress = { this.props.onKeyPress ? this.props.onKeyPress  : undefined }
							onChange = { this.props.onChange ? this.props.onChange  : undefined } 
							invalid = { this.props.validation && this.state.invalidField } 
							disabled = { this.props.disabled ? this.props.disabled : false }
							maxLength = {  this.props.maxLength ? this.props.maxLength : 64 }
							required = {  this.props.unrequired ? false : true }
							min = { this.props.min ? this.props.min : 0 }
							max = { this.props.max ? this.props.max : 0 }
							style = { this.props.style }
							onBlur = { this.props.onBlur ? this.props.onBlur : () => this.isValid(this.props.name) } />
						:
						<Input
							id = {this.props.tooltip ? this.props.name  : undefined } // tooltip necesita ID
							type = { this.props.type ? this.props.type : 'text'}
							name = { this.props.name ? this.props.name  : ''} 
							style = {{...this.props.style, height: `${this.props.customHeight}`}}
							value = {
								this.props.value
								? this.props.value
								: !Number.isNaN(this.props.value)  // si es un numero, muestralo! los valores con 0 son falsos en js...
									? this.props.value
									: ''
							}
							placeholder = { this.props.placeholder ? this.props.placeholder  : ''}
							onKeyUp = { this.props.onKeyUp ? this.props.onKeyUp  : undefined }
							onKeyDown = { this.props.onKeyDown ? this.props.onKeyDown  : undefined }
							onKeyPress = { this.props.onKeyPress ? this.props.onKeyPress  : undefined }
							onChange = { this.props.onChange ? this.props.onChange  : undefined } 
							invalid = { this.props.validation && this.state.invalidField } 
							disabled = { this.props.disabled ? this.props.disabled : false }
							maxLength = {  this.props.maxLength ? this.props.maxLength : 64 }
							required = {  this.props.unrequired ? false : true }
							onBlur = { this.props.onBlur ? this.props.onBlur : () => this.isValid(this.props.name) } />
					}

					{   
						/* Coloca un icono o  despues del input*/
						this.props.iconAppend?
						<InputGroupAddon addonType="append">
							<InputGroupText>
								{this.props.iconAppend}
							</InputGroupText>
						</InputGroupAddon>
						:
						(null)
					}

					{   
						/* Coloca un boton despues del input*/
						this.props.buttonAppend?
						<InputGroupAddon addonType="append">
                        	{this.props.buttonAppend}
						</InputGroupAddon>
						:
						(null)
					}

					{	/*
							docs del plugin ---> https://github.com/dockwa/simple-react-validator

							@validation.rules = string, cadena separada por | con la lista de reglas definidas por el plugin
							@validation.classes = string, cadenas con las clases del Css para mostrar msj de error
							@validation.errorMessages = Object, objeto con los mensajes de error para cada regla definida
						*/
						this.props.validation ?
							<FormFeedback>
								{this.validator.message(this.props.name, this.props.value, this.props.validation.rules, this.props.validation.classes, this.props.validation.errorMessages)}
							</FormFeedback>
						:
							null
					}

					
				</InputGroup>


				{ /* Recibe arreglo  de posiciones  0 = contenido, 1 = id, ejemplo: tooltip = {['ejemplo de tooltip','id'}*/
					this.props.tooltip ?
						<Tooltip 
							placement={this.props.tooltipPlacement? this.props.tooltipPlacement : 'right'} 
							isOpen={this.state.tooltipOpen[0]} 
							target={ /*this.props.tooltip[1] ? this.props.tooltip[1] :*/ this.props.name } 
							toggle={() => {this.toggle(0);}}>
							{ this.props.tooltip[0] }
						</Tooltip>	
					:
					null
				}
					
			</FormGroup>
		)
	}
}

export default InputNormal;



// WEBPACK FOOTER //
// ./src/views/Plugins/SpecialForm/InputNormal.js